import { useState, useMemo } from "react";

export const useSystemFilters = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSystemAdmin, setSelectedSystemAdmin] = useState(null);
  const [selectedIsCritical, setSelectedIsCritical] = useState(null);
  const [selectedIntegrationType, setSelectedIntegrationType] = useState(null);
  const [showFilters, setShowFilters] = useState(false);

  const filterObject = useMemo(() => {
    const filter = {};
    if (selectedSystemAdmin) filter.system_admin = [selectedSystemAdmin];
    if (selectedIsCritical !== null && selectedIsCritical !== undefined) filter.is_critical = selectedIsCritical;
    if (selectedIntegrationType) filter.integration_type = [selectedIntegrationType];
    return filter;
  }, [selectedSystemAdmin, selectedIsCritical, selectedIntegrationType]);

  const activeFiltersCount = [
    selectedSystemAdmin,
    selectedIsCritical !== null,
    selectedIntegrationType,
  ].filter(Boolean).length;

  const hasActiveFilters = searchQuery || selectedSystemAdmin || selectedIsCritical !== null || selectedIntegrationType;

  const clearFilters = () => {
    setSearchQuery("");
    setSelectedSystemAdmin(null);
    setSelectedIsCritical(null);
    setSelectedIntegrationType(null);
  };

  const removeFilter = (filterType) => {
    if (filterType === 'system_admin') setSelectedSystemAdmin(null);
    else if (filterType === 'is_critical') setSelectedIsCritical(null);
    else if (filterType === 'type') setSelectedIntegrationType(null);
  };

  return {
    searchQuery,
    setSearchQuery,
    selectedSystemAdmin,
    setSelectedSystemAdmin,
    selectedIsCritical,
    setSelectedIsCritical,
    selectedIntegrationType,
    setSelectedIntegrationType,
    showFilters,
    setShowFilters,
    filterObject,
    activeFiltersCount,
    hasActiveFilters,
    clearFilters,
    removeFilter,
  };
};

